import { useNoticeSnackbarStatus } from "./NoticeSnackbar";
import { useTodosStatus } from "../hooks";
import { SwipeableDrawer, List, ListItem, Divider } from "@mui/material";
import { NavLink } from "react-router-dom";

export default function TodoOptionDrawer({ status }) {
  const noticeSnackbarStatus = useNoticeSnackbarStatus();
  const todosStatus = useTodosStatus();

  const removeTodo = () => {
    if (
      window.confirm(`${status.todoId}번 할일을 삭제하시겠습니까?`) == false
    ) {
      status.close();
      return;
    }

    todosStatus.removeTodoById(status.todoId);
    status.close();
    noticeSnackbarStatus.open(
      `${status.todoId}번 할일이 삭제되었습니다.`,
      "info"
    );
  };

  const todo = todosStatus.findTodoById(status.todoId);

  return (
    <>
      <SwipeableDrawer
        anchor={"bottom"}
        onOpen={() => {}}
        open={status.opened}
        onClose={status.close}
      >
        <List className="!py-0">
          <ListItem className="!pt-6 !p-5">
            <span className="text-[color:var(--mui-color-primary-main)]">
              {todo?.id}번
            </span>
            <span>&nbsp;</span>
            <span>할일에 대해서</span>
          </ListItem>
          <Divider />
          <ListItem
            className="!pt-6 !p-5 !items-baseline"
            button
            onClick={removeTodo}
          >
            <i className="fa-solid fa-trash-can"></i>
            &nbsp;
            <span>할일 삭제</span>
          </ListItem>
          <ListItem
            className="!pt-6 !p-5 !items-baseline"
            button
            component={NavLink}
            to={`/edit/${todo?.id}`}
          >
            <i className="fa-solid fa-pen-to-square"></i>
            &nbsp;
            <span>할일 수정</span>
          </ListItem>
        </List>
      </SwipeableDrawer>
    </>
  );
}